import { render } from "./ConversationHistoryRedirect.vue?vue&type=template&id=16d2b89b&scoped=true"
import script from "./ConversationHistoryRedirect.vue?vue&type=script&lang=js"
export * from "./ConversationHistoryRedirect.vue?vue&type=script&lang=js"

import "./ConversationHistoryRedirect.vue?vue&type=style&index=0&id=16d2b89b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d2b89b"]])

export default __exports__